import React, { Component } from 'react';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';
import Footer from 'components/AppFooter/AppFooter';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS } = helpers;

import MetricsList from 'components/MetricsList';
import MetricsKey from 'components/Metrics/MetricsKey';
import ContentHeader from 'components/ContentHeader';
import Input from 'components/Input';
import Button from 'components/Button';
import ClassroomPanel from 'components/ClassroomPanel';
import Loader from 'components/Loader/Loader';
import Tabs from 'components/Tabs';

import { keyedObjToArr } from '../../util';


class Metrics extends Component {

	constructor (props) {
		super(props);

		this.state = {};
	}
	render () {

        if( !isLoaded(this.props.profile) ||
            !isLoaded(this.props.classrooms ||
			!isLoaded(this.props.orders ||
			!isLoaded(this.props.customers ||
			!isLoaded(this.props.schools ||
			!isLoaded(this.props.products)))))
        ) {
            return (
				<div className="main-content-area">
					<div className="page-content">
						<Loader color="main" size="large" />
					</div>
					<Footer/>
				</div>
            );
        }

        let classrooms;
        let profile;
        let selectedClassroom;

		if(this.props.params && this.props.params.classroomId)
            selectedClassroom = this.props.params.classroomId;

        //Not admin and not customer
        if(!this.props.profile.customer && this.props.profile.role !== 'admin') {

            return(
				<div className="main-content-area">
					<div className="page-content">
						<div><h3>No Customer for User</h3></div>
					</div>
				</div>
            );
        //Teacher and Not Admin
        } else if(this.props.classrooms && this.props.profile.classrooms && this.props.profile.role === 'teacher') {

            profile = this.props.profile;

            classrooms = keyedObjToArr(profile.classrooms).map( (classroom) => {
                if(!this.props.classrooms[classroom.id]) {
                    console.warn('couldnt find classrom with id ' + classroom.id);
                }
                return this.props.classrooms[classroom.id];
            });

            // Admin
        } else if(this.props.profile.role === 'admin') {
            classrooms = keyedObjToArr(this.props.classrooms);
        }

		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
				transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
				<div className="main-content-area" key="metrics">
					<ContentHeader
						title="Metrics"
						component={<MetricsKey
							orientation="horizontal"
						/>}
					/>
					<div className="page-content">
						<div className="container">
							<div className="main-list-area">
								<MetricsList
									profile={profile}
									classrooms={classrooms}
									products={this.props.products}
									orders={this.props.orders}
									schools={this.props.schools}
									customers={this.props.customers}
									selectedClassroom={selectedClassroom}
								/>
							</div>
						</div>
					</div>
				</div>
			</ReactCSSTransitionGroup>
		);
	}
}


const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (id) => { dispatch(openDrawer(id)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		openModal : (modal, props) => { dispatch(openModal(modal, props)); }
	};
};

const fbWrappedComponent = firebaseConnect( ({auth, profile}) => {
	if(!profile){
		return [];
	} else {
        return [
			{
                path: 'classrooms',
                storeAs: 'classrooms'
            },
			{
				path: 'products',
				storeAs: 'products'
			},
			{
				path: 'orders',
				storeAs: 'orders'
			},
			{
				path: 'schools',
				storeAs: 'schools'
			},
			{
				path: 'customers',
				storeAs: 'customers'
			}
        ];
	}
})(Metrics);

//Auth
const connectAuth = connect(
    ({ firebase }) => {
        return{
            profile: pathToJS(firebase, 'profile'),
        };
    }
)(fbWrappedComponent);

export default connect(
    ({ firebase }) => ({
        classrooms: dataToJS(firebase, 'classrooms'),
		products : dataToJS(firebase, 'products'),
		orders : dataToJS(firebase, 'orders'),
		schools : dataToJS(firebase, 'schools'),
		customers : dataToJS(firebase, 'customers')
    }),
    mapDispatchToProps
)(connectAuth);



// WEBPACK FOOTER //
// ./js/containers/Metrics/Metrics.js